import { List as VirtualizedList, AutoSizer } from "react-virtualized";

const List = (props) => {

    const { items = [], row_height = 100 } = props;
    const rowRenderer = ({ key, index, style }) => (
        <div key={key} style={style}>
            {items[index]}
        </div>
    );

    return (

        <AutoSizer>
            {({ width, height }) => (
                <VirtualizedList
                    className="vlist"
                    width={width}
                    height={height}
                    rowCount={items.length}
                    rowHeight={row_height}
                    rowRenderer={rowRenderer}
                />
            )}
        </AutoSizer>


    );
};

export default List;